(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["banner-and-video"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var videos = document.querySelectorAll('video[data-play-when-visible]');
    if (!videos.length) return;

    // No observer support: fall back to the old behaviour (load and play now).
    if (!('IntersectionObserver' in window)) {
      videos.forEach(function (video) {
        video.preload = 'auto';
        var played = video.play();
        if (played && played.catch) played.catch(function () {});
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var video = entry.target;

          if (entry.isIntersecting) {
            if (video.dataset.userPaused) return;
            if (video.preload !== 'auto') video.preload = 'auto';
            var played = video.play();
            if (played && played.catch) played.catch(function () {});
          } else if (!video.paused) {
            video.autoPausing = true;
            video.pause();
          }
        });
      },
      { rootMargin: '200px 0px', threshold: 0.25 }
    );

    videos.forEach(function (video) {
      // Don't fight a shopper who paused it themselves.
      video.addEventListener('pause', function () {
        if (video.autoPausing) {
          video.autoPausing = false;
          return;
        }
        // A blocked autoplay (iOS Low Power Mode, background tab) also fires
        // `pause`, with nothing ever played. Treating that as a deliberate
        // pause would keep the video stopped for the rest of the visit.
        if (!video.played.length) return;
        video.dataset.userPaused = 'true';
      });
      video.addEventListener('play', function () {
        delete video.dataset.userPaused;
      });

      observer.observe(video);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-categories-page"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var sections = document.querySelectorAll('.categories-page');

    sections.forEach(function (section) {
      var tabs = section.querySelectorAll('.categories-page__tab');
      var panels = section.querySelectorAll('.categories-page__panel');

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var index = tab.getAttribute('data-tab-index');

          tabs.forEach(function (t) {
            t.classList.remove('active');
            t.setAttribute('aria-selected', 'false');
          });
          tab.classList.add('active');
          tab.setAttribute('aria-selected', 'true');

          panels.forEach(function (p) {
            p.classList.remove('active');
          });
          var targetPanel = section.querySelector('[data-panel-index="' + index + '"]');
          if (targetPanel) {
            targetPanel.classList.add('active');
          }
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-category-drawer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var sections = document.querySelectorAll('.category-drawer-section');

    sections.forEach(function (section) {
      var sectionId = section.id.replace('CategoryDrawer-', '');
      var drawer = section.querySelector('.category-drawer');
      var tabs = section.querySelectorAll('.category-drawer__tab');
      var panels = section.querySelectorAll('.category-drawer__panel');
      var panelsContainer = section.querySelector('.category-drawer__panels');

      var scrollY = 0;
      var imagesHydrated = false;

      function hydrateImages() {
        if (imagesHydrated) return;
        imagesHydrated = true;
        var imgs = drawer.querySelectorAll('img[data-src]');
        imgs.forEach(function (img) {
          var ds = img.getAttribute('data-srcset');
          if (ds) {
            img.setAttribute('srcset', ds);
            img.removeAttribute('data-srcset');
          }
          img.setAttribute('src', img.getAttribute('data-src'));
          img.removeAttribute('data-src');
        });
      }

      /* Open */
      var openBtns = document.querySelectorAll('[data-category-drawer-open="' + sectionId + '"]');
      openBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          scrollY = window.scrollY;
          hydrateImages();
          section.classList.add('category-drawer--open');
          document.body.style.position = 'fixed';
          document.body.style.top = '-' + scrollY + 'px';
          document.body.style.left = '0';
          document.body.style.right = '0';
          document.body.style.overflow = 'hidden';
          btn.setAttribute('aria-expanded', 'true');
          var closeBtn = drawer.querySelector('.category-drawer__close');
          if (closeBtn) closeBtn.focus();
        });
      });

      /* Close */
      var closeBtns = section.querySelectorAll('[data-category-drawer-close="' + sectionId + '"]');
      closeBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          closeDrawer();
        });
      });

      /* Escape key */
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && section.classList.contains('category-drawer--open')) {
          closeDrawer();
        }
      });

      function closeDrawer() {
        section.classList.remove('category-drawer--open');
        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.left = '';
        document.body.style.right = '';
        document.body.style.overflow = '';
        window.scrollTo(0, scrollY);
        var openBtn = document.querySelector('[data-category-drawer-open="' + sectionId + '"]');
        if (openBtn) {
          openBtn.setAttribute('aria-expanded', 'false');
          openBtn.focus();
        }
      }

      /* Tab switching */
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var index = tab.getAttribute('data-tab-index');

          tabs.forEach(function (t) {
            t.classList.remove('active');
            t.setAttribute('aria-selected', 'false');
          });
          tab.classList.add('active');
          tab.setAttribute('aria-selected', 'true');

          panels.forEach(function (p) {
            p.classList.remove('active');
          });
          var targetPanel = section.querySelector('[data-panel-index="' + index + '"]');
          if (targetPanel) {
            targetPanel.classList.add('active');
          }
          if (panelsContainer) {
            panelsContainer.scrollTop = 0;
          }
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-collection-heading"]) return;
  try {
    
  // Sync product count from filters section into the collection heading
  (function () {
    function updateCount() {
      var source = document.querySelector('.products-count-wrapper span');
      var target = document.getElementById('collection-heading-count');
      if (source && target) {
        var text = source.textContent.trim();
        // Extract number from text like "3,723 items" or "25,000+ items"
        var match = text.match(/[\d,]+\+?/);
        if (match) {
          target.textContent = match[0] + ' items';
        }
      }
    }

    document.addEventListener('filter:update', function () {
      // Wait for the section to re-render
      setTimeout(updateCount, 500);
    });

    // Also observe DOM changes on the products-count-wrapper
    var observer = new MutationObserver(updateCount);
    var wrapper = document.querySelector('.products-count-wrapper');
    if (wrapper) {
      observer.observe(wrapper, { childList: true, subtree: true, characterData: true });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-topline-filters"]) return;
  try {
    
  function updateStickyOffsets() {
    var headerHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 60;
    var headingSection = document.querySelector('.collection-heading-section');
    var filtersSection = document.querySelector('.topline-filters-section');

    if (filtersSection) {
      var headingHeight = headingSection ? headingSection.offsetHeight : 0;
      filtersSection.style.setProperty('--topline-filters-top', (headerHeight + headingHeight - 11) + 'px');
    }
  }

  updateStickyOffsets();
  window.addEventListener('resize', updateStickyOffsets);

  function togglePillActive(pill, active) {
    var dot = pill.querySelector('.topline-filters__dot');
    if (active) {
      pill.classList.add('topline-filters__pill--active');
      if (dot) dot.hidden = false;
    } else {
      pill.classList.remove('topline-filters__pill--active');
      if (dot) dot.hidden = true;
    }
  }

  // Update pill active states when filters change
  document.addEventListener('filter:update', function () {
    // Use URL params (already updated by history.pushState) instead of
    // event.detail.queryParams which reads from form data that may be stale
    // (e.g. "Clear all" pushes clean URL but form inputs haven't cleared yet)
    var params = new URLSearchParams(window.location.search);

    var anyFilterActive = false;

    // Update individual filter pills
    document.querySelectorAll('.topline-filters__pill--filter[data-filter-param]').forEach(function (pill) {
      var paramName = pill.getAttribute('data-filter-param');
      if (!paramName) return;
      // Skip sort pill here
      if (pill.id === 'topline-filter-sort') return;

      var hasActive = false;
      params.forEach(function (value, key) {
        if (key === paramName || key.startsWith(paramName + '.')) {
          if (value !== '' && value !== '0') {
            hasActive = true;
          }
        }
      });

      togglePillActive(pill, hasActive);
      if (hasActive) anyFilterActive = true;
    });

    // Update main Filter pill
    var mainPill = document.getElementById('topline-filter-main');
    if (mainPill) {
      togglePillActive(mainPill, anyFilterActive);
    }

    // Update Sort pill
    var sortPill = document.getElementById('topline-filter-sort');
    if (sortPill) {
      var defaultSort = sortPill.getAttribute('data-default-sort') || '';
      var currentSort = params.get('sort_by') || '';
      var sortActive = currentSort !== '' && currentSort !== defaultSort;
      togglePillActive(sortPill, sortActive);
    }
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  /* Only on a fresh visit to a link that carries a product's anchor. On Back or
     a reload restoreTappedCard() in assets/results-list.js puts the page where
     it was, and this ran after it: a page that had not been scrolled was at 0,
     so it jumped down to the tapped product (237px in a test) and went back up
     when the page finished loading. In the app that was hidden behind the
     shell's picture of the page for as long as the picture stayed. */
  const navigation = performance.getEntriesByType('navigation')[0];
  if (url.hash && (!navigation || navigation.type === 'navigate')) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        /* The browser may already have gone to the anchor itself. */
        if (window.scrollY > 0) return;
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  document.addEventListener('click', function (e) {
    var pill = e.target.closest('.inline-filter__pill');
    if (pill) {
      var paramName = pill.getAttribute('data-param-name');
      var value = pill.getAttribute('data-value');
      var isActive = pill.getAttribute('data-active') === 'true';

      if (!paramName || value === null) return;

      var url = new URL(window.location.href);

      if (isActive) {
        var entries = Array.from(url.searchParams.entries());
        var newParams = new URLSearchParams();
        for (var i = 0; i < entries.length; i++) {
          if (entries[i][0] === paramName && entries[i][1] === value) continue;
          newParams.append(entries[i][0], entries[i][1]);
        }
        url.search = newParams.toString();
      } else {
        url.searchParams.append(paramName, value);
      }

      url.searchParams.delete('page');

      var facetsForm = document.querySelector('facets-form-component');
      if (!facetsForm || typeof facetsForm.updateFiltersByURL !== 'function') {
        window.location.href = url.toString();
        return;
      }

      var sectionEl = facetsForm.closest('.shopify-section');
      var prefetchUrl =
        url.pathname +
        url.search +
        (url.search ? '&' : '?') +
        'section_id=' +
        (sectionEl ? sectionEl.id.replace('shopify-section-', '') : '');
      fetch(prefetchUrl);

      if (window.scrollY > 0) {
        window.scrollTo({ top: 0, behavior: 'smooth' });

        var scrollRaf;
        var onScrollDone = function () {
          cancelAnimationFrame(scrollRaf);
          document.removeEventListener('scrollend', onScrollDone);
          facetsForm.updateFiltersByURL(url.toString());
        };

        document.addEventListener('scrollend', onScrollDone, { once: true });

        var pollScroll = function () {
          if (window.scrollY <= 1) {
            onScrollDone();
            return;
          }
          scrollRaf = requestAnimationFrame(pollScroll);
        };
        scrollRaf = requestAnimationFrame(pollScroll);

        setTimeout(function () {
          onScrollDone();
        }, 800);
      } else {
        facetsForm.updateFiltersByURL(url.toString());
      }
      return;
    }

    var moreBtn = e.target.closest('[data-inline-open-filters-drawer]');
    if (moreBtn) {
      var drawer = document.getElementById('filters-drawer');
      if (!drawer) return;

      if (typeof drawer.showDialog === 'function') {
        drawer.showDialog();
      } else {
        var dialog = drawer.querySelector('dialog');
        if (dialog) dialog.showModal();
      }

      var filterLabel = moreBtn.getAttribute('data-filter-label');
      if (!filterLabel) return;

      requestAnimationFrame(function () {
        setTimeout(function () {
          var dialog = drawer.querySelector('dialog');
          if (!dialog) return;

          var targetItem = null;
          var sidebarItems = dialog.querySelectorAll('.fd-sidebar__item');
          for (var i = 0; i < sidebarItems.length; i++) {
            var sidebarLabel = sidebarItems[i].querySelector('.fd-sidebar__label');
            if (sidebarLabel && sidebarLabel.textContent.trim().toLowerCase() === filterLabel.toLowerCase()) {
              targetItem = sidebarItems[i];
              break;
            }
          }

          if (!targetItem) return;
          var fdTarget = targetItem.getAttribute('data-fd-target');
          if (!fdTarget) return;

          dialog.querySelectorAll('.fd-sidebar__item').forEach(function (item) {
            item.classList.remove('fd-sidebar__item--active');
          });
          targetItem.classList.add('fd-sidebar__item--active');
          targetItem.scrollIntoView({ behavior: 'smooth', block: 'nearest' });

          dialog.querySelectorAll('.fd-panel').forEach(function (panel) {
            if (panel.getAttribute('data-fd-panel') === fdTarget) {
              panel.classList.add('fd-panel--visible');
            } else {
              panel.classList.remove('fd-panel--visible');
            }
          });
        }, 150);
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-list"] && !Shopify.designMode) return;
  try {
    
  // The rest of the cards for split lists (see the Liquid at the top of this
  // file). Fetching page 2 of this same section returns the remaining cards,
  // rendered by the same code with the same block settings.
  (function () {
    var lists = document.querySelectorAll('[data-product-list-rest]');
    if (!lists.length) return;

    function appendSlides(list, incoming) {
      var scroller = list.querySelector('slideshow-slides');
      var slides = incoming.querySelectorAll('slideshow-slides > slideshow-slide');

      if (!scroller || !slides.length) {
        // Grid layout: the items sit directly in the list.
        incoming.querySelectorAll(':scope > .resource-list__item').forEach(function (item) {
          list.appendChild(item);
        });
        return;
      }

      var offset = scroller.querySelectorAll('slideshow-slide').length;

      slides.forEach(function (slide, index) {
        // Each slide names a scroll timeline after its index, and the fetched
        // page numbers its slides from 0 again — continue this row's numbering.
        slide.style.setProperty('--slideshow-timeline', '--slide-' + (offset + index));
        slide.setAttribute('aria-hidden', 'true');
        scroller.appendChild(slide);
      });

      // The carousel sets up its observers and controls once, when it is
      // connected, so replace it with a copy of itself to re-run that with
      // every slide present. This happens while the section is still off
      // screen, so nothing visibly changes.
      var carousel = list.querySelector('slideshow-component');
      if (carousel) carousel.replaceWith(carousel.cloneNode(true));
    }

    function loadRest(root) {
      if (root.dataset.productListRestLoaded) return;
      root.dataset.productListRestLoaded = 'true';

      var url = new URL(window.location.href);
      url.searchParams.set('section_id', root.dataset.productListRest);
      url.searchParams.set('page', '2');

      // Pass a string: CleverTap's fetch wrapper (/a/s/shopifyEvents.js) calls
      // .includes() on the input and rejects the promise for a URL object.
      fetch(url.toString())
        .then(function (response) {
          if (!response.ok) throw new Error('Product list: HTTP ' + response.status);
          return response.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var incomingLists = doc.querySelectorAll('.resource-list');

          root.querySelectorAll('.resource-list').forEach(function (list, index) {
            if (incomingLists[index]) appendSlides(list, incomingLists[index]);
          });

          // Paint saved-state hearts on the new cards (wishlist-controller_v2.js).
          document.dispatchEvent(new CustomEvent('wishlist:v2:refresh'));
        })
        .catch(function () {
          delete root.dataset.productListRestLoaded; // let a later pass retry
        });
    }

    if (!('IntersectionObserver' in window)) {
      lists.forEach(loadRest);
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          observer.unobserve(entry.target);
          loadRest(entry.target);
        });
      },
      { rootMargin: '800px 0px' }
    );

    lists.forEach(function (root) {
      observer.observe(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search-heading"]) return;
  try {
    
  // Sync product count from filters section into the search heading
  (function () {
    function updateCount() {
      var source = document.querySelector('.products-count-wrapper span');
      var target = document.getElementById('collection-heading-count');
      if (source && target) {
        var text = source.textContent.trim();
        var match = text.match(/[\d,]+\+?/);
        if (match) {
          target.textContent = match[0] + ' items';
        }
      }
    }

    document.addEventListener('filter:update', function () {
      setTimeout(updateCount, 500);
    });

    var observer = new MutationObserver(updateCount);
    var wrapper = document.querySelector('.products-count-wrapper');
    if (wrapper) {
      observer.observe(wrapper, { childList: true, subtree: true, characterData: true });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search-results"]) return;
  try {
    
  /* Scroll indicator for no-results bestsellers */
  (function () {
    var scroller = document.querySelector('.search-no-results__products-scroll');
    var thumb = document.querySelector('.search-no-results__scroll-thumb');
    if (scroller && thumb) {
      function updateThumb() {
        var sw = scroller.scrollWidth;
        var cw = scroller.clientWidth;
        if (sw <= cw) {
          thumb.style.width = '100%';
          thumb.style.transform = 'translateX(0)';
          return;
        }
        var ratio = cw / sw;
        var scrollRatio = scroller.scrollLeft / (sw - cw);
        var trackWidth = thumb.parentElement.clientWidth;
        var thumbWidth = Math.max(ratio * trackWidth, 30);
        var maxT = trackWidth - thumbWidth;
        thumb.style.width = thumbWidth + 'px';
        thumb.style.transform = 'translateX(' + (scrollRatio * maxT) + 'px)';
      }
      scroller.addEventListener('scroll', updateThumb, { passive: true });
      updateThumb();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search-topline-filters"]) return;
  try {
    
  function updateStickyOffsets() {
    var headerHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 60;
    var headingSection = document.querySelector('.collection-heading-section');
    var filtersSection = document.querySelector('.topline-filters-section');

    if (filtersSection) {
      var headingHeight = headingSection ? headingSection.offsetHeight : 0;
      filtersSection.style.setProperty('--topline-filters-top', (headerHeight + headingHeight - 11) + 'px');
    }
  }

  updateStickyOffsets();
  window.addEventListener('resize', updateStickyOffsets);

  function togglePillActive(pill, active) {
    var dot = pill.querySelector('.topline-filters__dot');
    if (active) {
      pill.classList.add('topline-filters__pill--active');
      if (dot) dot.hidden = false;
    } else {
      pill.classList.remove('topline-filters__pill--active');
      if (dot) dot.hidden = true;
    }
  }

  document.addEventListener('filter:update', function () {
    var params = new URLSearchParams(window.location.search);
    var anyFilterActive = false;

    document.querySelectorAll('.topline-filters__pill--filter[data-filter-param]').forEach(function (pill) {
      var paramName = pill.getAttribute('data-filter-param');
      if (!paramName) return;
      if (pill.id === 'topline-filter-sort') return;

      var hasActive = false;
      params.forEach(function (value, key) {
        if (key === paramName || key.startsWith(paramName + '.')) {
          if (value !== '' && value !== '0') {
            hasActive = true;
          }
        }
      });

      togglePillActive(pill, hasActive);
      if (hasActive) anyFilterActive = true;
    });

    var mainPill = document.getElementById('topline-filter-main');
    if (mainPill) {
      togglePillActive(mainPill, anyFilterActive);
    }

    var sortPill = document.getElementById('topline-filter-sort');
    if (sortPill) {
      var defaultSort = sortPill.getAttribute('data-default-sort') || '';
      var currentSort = params.get('sort_by') || '';
      var sortActive = currentSort !== '' && currentSort !== defaultSort;
      togglePillActive(sortPill, sortActive);
    }
  });

  } catch(e) { console.error(e); }
})();
})();
